import { apiHelper } from './api_helper';

export const hinhThucMienGiamApi = {
    SelectByNamHocAsync: (nam_hoc, ts_hocsinh_id, dm_coso_id) => apiHelper.get(`hinhthucmiengiam/select_all_by_namhoc/${nam_hoc}/${ts_hocsinh_id}/${dm_coso_id}`),
    SelectByHocSinhAsync: (nam_hoc, ts_hocsinh_id) => apiHelper.get(`hinhthucmiengiam/select_by_hocsinh/${nam_hoc}/${ts_hocsinh_id}`),
    InsertAsync: (data) => apiHelper.post(`hinhthucmiengiam/insert_de_xuat_mien_giam`,data),
    DeleteAsync: (data) => apiHelper.post(`hinhthucmiengiam/delete_de_xuat_mien_giam`,data),
}

